import { Box, CssBaseline, GlobalStyles, ThemeProvider } from "@mui/material";
import theme from "./theme/muiTheme";
import AppRoutes from "./routes";

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          body: { margin: 0, padding: 0, backgroundColor: "#f9fafb" },
        }}
      />
      <Box sx={{ minHeight: "100vh", bgcolor: "#f5f7fb" }}>
        <AppRoutes />
      </Box>
    </ThemeProvider>
  );
}
